var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { childrenPropType } from './propTypes';
import pure from '../HOC/pure';
var dataListClassName = 'widget-data-list';

var Thumb = function Thumb(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return React.createElement('div', _extends({}, props, {
    className: dataListClassName + '__scrollbar-thumb'
  }));
};

var NoDataMessage = function NoDataMessage(_ref2) {
  var message = _ref2.message;
  return React.createElement('div', {
    className: dataListClassName + '__no-data-message'
  }, message);
};

NoDataMessage.propTypes = {
  message: PropTypes.node.isRequired
};

var DataListElement = function DataListElement(_ref3) {
  var Element = _ref3.Element,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ['Element', 'children']);

  return Element ? React.createElement(Element, props, children) : React.createElement('table', props, React.createElement('tbody', null, children));
};

export { DataListElement };
DataListElement.propTypes = {
  Element: PropTypes.string,
  children: childrenPropType
};
DataListElement.defaultProps = {
  Element: null,
  children: null
};
/* eslint-disable react/no-array-index-key */

var DataList = function DataList(_ref4) {
  var data = _ref4.data,
      noDataMessage = _ref4.noDataMessage,
      RowComponent = _ref4.RowComponent,
      element = _ref4.element,
      scrollable = _ref4.scrollable;

  if (data.length === 0) {
    return React.createElement(NoDataMessage, {
      message: noDataMessage
    });
  }

  var body = React.createElement(DataListElement, {
    className: dataListClassName,
    Element: element
  }, data.map(function (rowData, index) {
    return React.isValidElement(RowComponent) ? React.cloneElement(RowComponent, _extends({
      key: 'row' + index,
      index: index
    }, rowData)) : React.createElement(RowComponent, _extends({
      key: 'row' + index,
      index: index
    }, rowData));
  }));

  if (!scrollable) {
    return body;
  }

  return React.createElement(Scrollbars, {
    renderThumbHorizontal: Thumb,
    renderThumbVertical: Thumb,
    className: dataListClassName + '-scrollbars'
  }, body);
};

DataList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  RowComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  noDataMessage: PropTypes.node,
  scrollable: PropTypes.bool,
  element: PropTypes.string
};
DataList.defaultProps = {
  scrollable: true,
  noDataMessage: 'Empty data',
  element: null
};
export default pure()(DataList);